import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DetailsPage as ProjectDetailsPage } from 'src/app/projects/details/details.page';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-schedule-changed-projects',
  templateUrl: './schedule-changed-projects.component.html',
})
export class ScheduleChangedProjectsComponent {
  @Input() changed_projects: any[] = [];
  @Input() assigned_clients: any[] = [];
  @Input() assigned_companies: any[] = [];

  constructor(private modalController: ModalController) {}

  getLinkedName(project: any): string {
    if (project.client_guid) {
      const client = this.assigned_clients.find(c => c.guid === project.client_guid);
      if (client) return client.display_name;
    }
    if (project.company_guid) {
      const company = this.assigned_companies.find(c => c.guid === project.company_guid);
      if (company) return company.name;
    }
    return project.linked_name || '';
  }

  fmt(d: string): string {
    return d ? dayjs(d).format('MMM D, YYYY') : '—';
  }

  async ViewProject(project: any) {
    const modal = await this.modalController.create({
      component: ProjectDetailsPage,
      cssClass: 'large-modal secondary-modal',
      componentProps: { guid: project.guid },
      backdropDismiss: false,
    });
    await modal.present();
  }

  Close() {
    this.modalController.dismiss();
  }
}
